import { BrowserClient, Hub } from '@sentry/browser';

let hub: Hub;

export const initializeSentry = (dsn: string) => {
  hub = new Hub(new BrowserClient({ dsn, environment: process.env.NODE_ENV }));
  console.log('Sentry configured with dsn', dsn, 'and environment', process.env.NODE_ENV);
  hub.configureScope((scope) => {
    scope.setTags({ version: process.env.REACT_APP_VERSION || 'undefined' });
  });
};

export const withSentryHub = () => {
  return hub;
};
